import { gql } from '@apollo/client';

export const ORGANIZATION = gql`
  query Organization($id: Int!) {
    organization(id: $id) {
      id
      name
      created
    }
  }
`;

export const ORGANIZATIONS = gql`
  query Organizations($page: Int!, $size: Int!, $name: String, $sort: [String]) {
    organizations(page: $page, size: $size, name: $name, sort: $sort) {
      results {
        id
        name
        created
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const UPDATE_ORGANIZATION = gql`
  mutation UpdateOrganization($id: Int!, $name: String!) {
    updateOrganization(id: $id, name: $name)
  }
`;

export const CREATE_ORGANIZATION = gql`
  mutation CreateOrganization($name: String!) {
    createOrganization(name: $name) {
      id
      name
      created
    }
  }
`;

export const ORGANIZATION_MEMBERS = gql`
query OrganizationMembers($params: OrganizationMembersRequestParams!) {
  organizationMembers(params: $params) {
    results {
      id
      name
      email
      lastLogin
      accountState
    }
    pagination {
      currentPage
      pageSize
      totalPages
      totalResults
    }
  }
}
`;
